import React from 'react';
import { Typography } from '@mui/material';
import { mvkgTokens } from '../../theme/mvkgTokens';

export default function Kicker({ children, sx = {} }) {
  return (
    <Typography
      component="div"
      sx={{
        fontFamily: mvkgTokens.font.mono,
        // 11px: 10px overlines were the single largest detector finding on the
        // admin surfaces (31 labels below the legibility floor).
        fontSize: '0.6875rem',
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
